<template>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submit)">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">
              {{ form.id ? 'Update Import' : 'New Import' }}
            </h4>
          </div>
          <div class="card-body">
            <div class="form-group">
            <label>Barangay</label>
            <ValidationProvider name="start_date" rules="required" v-slot="{ passed, failed }">
              <el-select v-model="form.barangay_id" placeholder="Select">
                <el-option v-for="barangay,i in barangays" :key="i" :label="barangay.name" :value="barangay.id" :class="[
                       { 'has-danger': failed },
                       { 'has-success': passed }]">
                </el-option>
              </el-select>
              <br><span class="error-text" v-if="failed">Barangay is required</span>
            </ValidationProvider>
          </div>


          <file-upload @change="setFiles($event)" :multiple="false"></file-upload>
          <hr>
          <div><a href="/voters-list-per-brgy.xlsx" class="link">Download the excel template <i class="fa fa-download"></i></a></div>
          
          </div>
          <div class="card-footer text-right">
            <p-button type="info" native-type="submit">Save</p-button>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </template>
  <script>
  import { extend } from "vee-validate";
  import { required } from "vee-validate/dist/rules";
  import { BarangayImport } from '@/resources/barangay_import'
  import { Barangay } from '@/resources/barangay'
import FileUpload from '../../Dashboard/Views/Components/FileUpload.vue';

  extend("required", required);
  
  export default {
  components: { FileUpload },
    props: ['import'],
    data() {
      return {
        form: {
          name: "",
        },
        loading: false,
        barangays: [],
        file: null
      };
    },
    watch: {
      voter: function () {
        if (this.import) this.form = Object.assign({}, this.import)
      }
    },
    created: function () {
      this.getBarangays()
      if (this.import) this.form = Object.assign({}, this.import)
    },
    beforeDestroy() {
      this.form = {
        name: "",
      }
    },
    methods: {
      setFiles(files) {
        this.file = files[0]
      },
      submit() {  
        if (!this.file) {
            this.$notify({
              type: 'danger',
              title: "Error",
              text: 'File is required',
            });
            return
          }
        this.loading = true
        let request = this.form.id ? BarangayImport.update(this.form) : BarangayImport.create(this.getFormData())
  
        request
          .then(result => {
            this.$notify({
              type: 'success',
              title: "Success",
              text: 'Import has been saved',
            });
            this.$emit('save', true)
          })
          .catch(error => {
        
          }).finally(() => {
            this.loading = false
          })
      },
      getBarangays() {
        let params = {  page: 1, per_page: 99999 , name_only: 1}
        this.loading = true
        Barangay.get(params)
          .then(result => {
            if (result.data.barangays)
              this.barangays = result.data.barangays
          })
          .catch(() => {
            this.$notify({
              type: 'danger',
              title: "Error",
              text: 'Unable to fetch barangays',
            });
  
          }).finally(() => {
            this.loading = false
          })
      },
      getFormData() {
          var formData = new FormData()
          formData.append('barangay_id', this.form.barangay_id)
          
          formData.append('file', this.file.raw)

          return formData
        }
    }
  }
  </script>
  <style></style>
  